import React, {useContext, useEffect} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {Col, Container, Row, Spinner} from "react-bootstrap";
import ReactPaginate from 'react-paginate';

function PagesURL(props) {
    let {getParts, offset, setOffset, perPage, parts, pageCount} = useContext(StateContext);

  //  console.log(props.pageURL);

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setOffset(selectedPage * perPage)
    };


    useEffect(() => {
      //  getParts(props.modelId)
        if(props.modelId){
            getParts(props.modelId,"")
        }else {
            getParts("",props.pageURL)
        }



    }, [props.modelId])

    useEffect(() => {
        if(props.modelId){
            getParts(props.modelId,"")
        }else {
            getParts("",props.pageURL)
        }

        window.scrollTo({ top: 0, behavior: 'smooth' })

    }, [offset])


    // render JSX
    return (
        <div >
            <Container>
                <Row className="center-text">
                    <Col>

                        <div className="App">
                            <div>
                                <section className="products">
                                    {parts.length > 0 ? parts :  <div className="center-text items padTop"><Spinner animation="border" /></div>}
                                </section>
                            </div>

                        </div>
                    </Col>

                </Row>
                <Row className="center-text">
                    <Col></Col>
                    <Col>
                        {pageCount > 0 ? <ReactPaginate
                            hrefBuilder={(page, pageCount, selected) =>
                                page >= 1 && page <= pageCount ? `/catalog/${page}` : '#'
                            }
                            hrefAllControls
                            forcePage={props.pageURL}
                            previousLabel={"prev"}
                            nextLabel={"next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} /> :  ""}

                    </Col>
                    <Col></Col>
                </Row>
            </Container>


        </div>
    )
}

export default PagesURL
